import { Thread } from "./thread";

export class Pcn extends Thread {}

export class FileData {
  fileName: string = "";
  fileContent: string = "";
}
